import { Button } from '@mui/material'
import React from 'react'

interface PropsType {
    children: React.ReactNode;
    color: string;
    width?: string;
    onClick: () => void;
    type?: string; //rounded (for border-radius)
    disabled?: boolean;
}

function OutlineButton({ children, color, onClick, width, type, disabled = false }: PropsType): JSX.Element {

    const handleClick = (): void => {
        onClick()
    }
       return (
        <>
            {
                color === "red" &&
                <Button
                    variant="outlined"
                    sx={{
                        background: '#fff',
                        borderRadius: type !== undefined ? '100px' : '',
                        color: '#D6242C',
                        padding: '0px 15px',
                        height: '40px',
                        fontSize: '14px',
                        fontWeight: '600',
                        transition: 'background 0.3s',
                        textTransform: 'none',
                        width: width !== undefined ? width : 'auto',
                        border: '1px solid #D6242C',
                        fontFamily: 'Manrope',
                        '&:hover': {
                            background: '#ffaeb2',
                            border: '1px solid #D6242C',
                        },
                    }}
                    onClick={handleClick}
                    disabled={disabled}
                >
                    {children}
                </Button>
            }
            {
                color === 'gray' &&
                <Button
                    variant="outlined"
                    sx={{
                        color: '#3A3A3A',
                        border: '1px solid #CBD1DC',
                        borderRadius: '50px',
                        fontSize: '14px',
                        textTransform: 'none',
                        fontFamily: 'Manrope',
                        background: '#FAFAFA',
                        fontWeight: '600',
                        width: width !== undefined ? width : 'auto',
                        '&:hover': {
                            background: '#e9e9e9',
                            border: '1px solid #CBD1DC',
                        }
                    }}
                    onClick={handleClick}
                    disabled={disabled}
                >
                    {children}
                </Button>
            }
        </>
    )
}

export default OutlineButton